import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { Row as BasicRow } from '@/components/Row';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Container)<{ $hasTopSpacing?: boolean }>`
  text-align: center;

  ${({ $hasTopSpacing, theme }) => css`
    padding-bottom: ${theme.spacing(5)};

    /* The checkout entry drops the Contentful hero, which used to separate the
       panels from the site header. Match the bottom padding so the gap is even
       above and below. Not applied to the standard My Account login, which
       still renders its hero. */
    ${$hasTopSpacing && `padding-top: ${theme.spacing(5)};`}
  `}
`;

export const Row = styled(BasicRow)`
  grid-gap: ${({ theme }) => theme.spacing(2)};
`;

export const TabsWrapper = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};

    ${theme.media.sm.up} {
      display: none;
    }
  `}
`;

export const Panel = styled(Col)<{ $isActive: boolean }>`
  ${({ $isActive, theme }) => css`
    ${theme.media.sm.down} {
      display: ${$isActive ? 'block' : 'none'};
    }
  `}
`;

export const GlobalEMessageWrapper = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  max-width: 646px;
  margin: 0 auto ${({ theme }) => theme.spacing(5)};
`;

export const GlobalETitle = styled(Typography)`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.h6};
  text-transform: uppercase;
`;

export const GlobalEDescription = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSizes.p4};
  line-height: ${({ theme }) => theme.lineHeights.p3};
`;
